<template>
<v-dialog v-model="popup.show" max-width="500px" transition="slide-y-reverse-transition" persistent scrollable>
  <v-card>
    <v-card-title class="pa-0">
      <v-toolbar class="pl-2" color="transparent" flat>
        <v-spacer></v-spacer>
        <v-toolbar-title class="headline ml-4">{{popup.type}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          @click.native="popup.show = false"
          icon
          flat
        ><v-icon>close</v-icon></v-btn>
      </v-toolbar>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-layout row wrap>
        <v-flex v-if="popup.type == 'Resetting'" xs12 class="text-xs-center px-3 pb-3 pt-1">
          <div class="subheading pb-2">You will lose all unsaved changes</div>
          <div class="subheading pb-3">Are you sure?</div>
          <div>
            <v-btn @click.native="broadcast('reset')" color="error" depressed>Reset</v-btn>
          </div>
        </v-flex>
        <v-flex v-if="popup.type == 'Creating Content' || popup.type == 'Updating Content'" xs12 class="text-xs-center px-3 pb-3 pt-1">
          <div class="subheading pb-2">
            Content <b>{{newC.name}}</b> will be {{popup.type == 'Creating Content' ? 'created' : 'updated'}}
          </div>
          <div class="subheading"><b>Instructions</b></div>
          <div class="subheading pb-2">{{newC.instructions}}</div>
          <div>
            <v-btn
              @click.native="broadcast(popup.type == 'Creating Content' ? 'createContent' : 'updateContent')"
              color="success"
              depressed
            >{{popup.type == 'Creating Content' ? 'Create' : 'Update'}}</v-btn>
          </div>
        </v-flex>
        <v-flex v-if="popup.type == 'Creating Section' || popup.type == 'Updating Section'" xs12 class="text-xs-center px-3 pb-3 pt-1">
          <div class="subheading pb-2">
            Section <b>{{newS.name}}</b> will be {{popup.type == 'Creating Section' ? 'created' : 'updated'}}
          </div>
          <div class="subheading"><b>Instructions</b></div>
          <div class="subheading pb-2">{{newS.instructions}}</div>
          <div>
            <v-btn
              @click.native="broadcast(popup.type == 'Creating Section' ? 'createSection' : 'updateSection')"
              color="success"
              depressed
            >{{popup.type == 'Creating Section' ? 'Create' : 'Update'}}</v-btn>
          </div>
        </v-flex>
        <v-flex v-if="popup.type == 'Deleting Video'" xs12 class="text-xs-center px-3 pb-3 pt-1">
          <div class="subheading pb-2">Deleting <b>{{newT.name}}'s</b> video</div>
          <div class="subheading pb-2">This action is not reversable</b></div>
          <div class="subheading pb-3">Continue?</div>
          <div>
            <v-btn @click.native="broadcast('deleteVideo')" color="error" depressed>Delete</v-btn>
          </div>
        </v-flex>
        <v-flex v-if="popup.type == 'Deleting Section' || popup.type == 'Deleting Content'" xs12 class="text-xs-center px-3 pb-3 pt-1">
          <div class="subheading pb-2">Deleting <b>{{deletingData.name}}</b></div>
          <div class="subheading pb-2">This action cannot be reversed!</div>
          <div class="subheading pb-2">Continue?</div>
          <div>
            <v-btn @click.native="broadcast('delete')" color="error" depressed><b>Delete</b></v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
import {contentEvent} from '../../main'
export default {
  props: ['popup', 'contentData', 'sectionData', 'deletingData'],
  computed: {
    newC () {
      return this.contentData ? this.contentData : {}
    },
    newS () {
      return this.sectionData ? this.sectionData : {}
    },
    deletingD () {
      return this.deletingData ? this.deletingData : {}
    }
  },
  methods: {
    broadcast (event) {
      contentEvent.$emit(event)
      this.popup.show = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/ContentPopup.vue